import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useCatalogSampleTypesQuery } from "./hooks/queries/useCatalogSampleTypesQuery";
import { TableSampleType } from "./components/TableSampleType";

export const CatalogSampleTypePage = () => {
  const { sampleTypeId } = useParams();
  const { data: sampleTypes, isLoading, error } = useCatalogSampleTypesQuery();
  const [errorMessage, setErrorMessage] = useState("");

  return (
    <>
      <HelmetDexteel title={"Sample Types"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableSampleType
              sampleTypeId={sampleTypeId}
              sampleTypes={sampleTypes ?? null}
              isLoading={isLoading}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal
        error={error?.message || errorMessage}
        onHide={() => setErrorMessage("")}
      />
    </>
  );
};
